/**
 * A type that represents the primary key of a model
 */
export type EntityId = number | string;

/**
 * A function that returns the primary key of a model
 */
export type IdSelector<T, Id extends EntityId> = (model: T) => Id;

/**
 * A state that stores entities in a normalized form
 */
export interface EntityState<T, Id extends EntityId> {
  ids: Id[];
  entities: Record<Id, T>;
}

/**
 * A factory for creating empty {@link EntityState}
 */
export interface EntityStateFactory<T, Id extends EntityId> {
  createInitialState(state?: undefined): EntityState<T, Id>;
  createInitialState<S extends object>(state: S): EntityState<T, Id> & S;
}

/**
 * Creates an {@link EntityStateFactory} to return an empty {@link EntityState}
 */
export const createEntityStateFactory = <T, Id extends EntityId>(): EntityStateFactory<T, Id> => ({
  createInitialState: <S extends object>(state?: S): EntityState<T, Id> & S => ({
    ...((state ?? {}) as S),
    entities: {} as Record<Id, T>,
    ids: [] as Id[],
  }),
});
